import {Component, forwardRef, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {GroupBlock} from '../../../shared/models/form-schema.model';
import {BlockRendererComponent} from '../block-renderer/block-renderer.component';

@Component({
  selector: 'forms-group-block',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, forwardRef(() => BlockRendererComponent)],
  template: `
    <div class="group-block border border-gray-100 rounded-2xl p-4 mb-5 bg-gray-50/50">
      <h3 *ngIf="block.label" class="text-lg font-bold text-gray-800 mb-4 tracking-tight">{{ block.label }}</h3>
      <div [formGroup]="group">
        <div class="space-y-4">
          @for (subBlock of block.blocks; track subBlock.id) {
            <forms-block-renderer
              [block]="subBlock"
              [parentForm]="group">
            </forms-block-renderer>
          }
        </div>
      </div>
    </div>
  `
})
export class GroupBlockComponent {
  @Input() block!: GroupBlock;
  @Input() group!: FormGroup;
}
